<template>
  <div class="cart">
    <TopNavbar title="购物车"></TopNavbar>
    <div class="no-good" v-if="!this.cartList.length">
      <Empty
          class="empty-cart"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
          description="购物车空空的"
      ></Empty>
      <Button type="warning" size="small" class="btn-home" @click="toBack">返回继续购物</Button>
      <Button size="small" class="btn-home" @click="toMyOrder">查看我的订单</Button>
    </div>
    <div v-else>
      <div class="address" @click="goAddressList" :editable="false">
        <div class="address-container">
          <div v-if="hasDefaultAddress" class="address-box">
            <div class="location-container">
              <icon name="location"/>
            </div>
            <div class="address-item">
              <div class="address-top">
                <span class="user-info">{{defaultAddress.name}}</span>
                <span class="phonenum">{{defaultAddress.tel}}</span>
              </div>
              <div class="address-bottom">
                <div class="address-info">{{fullAddress}}</div>
              </div>
            </div>
            <div class="next-icon">
              <icon name="arrow"/>
            </div>
          </div>
          <div v-else class="location-add-tip">
            <div class="location-icon-add">
              <icon name="plus"/>
            </div>
            <div>请输入地址</div>
          </div>
        </div>
      </div>

      <div class="cart-goods">
        <div class="card-goods__item" v-for="item in cartList" :key="item.skuCombId" :name="item.skuCombId">
          <card :title="getTitle(item)" :num="item.Cartcount" :price="formatPrice(item.price)"
                :thumb="item.coverUrl">
            <div slot="tags" class="cart-tags">
              <div class="tag-list">
                <tag plain type="danger" class="tag-info" v-for="t in item.activityTags" :key="t"> {{t}}</tag>
              </div>
            </div>
            <div slot="footer" class="footer">
              <Button class="btn" size="mini" @click.stop="reduceCount(item, item.Cartcount)">-</Button>
              <span class="input">
                  <span class="input-edit">{{item.Cartcount}}</span>
              </span>
              <Button class="btn" size="mini" @click.stop="addCount(item, item.Cartcount)">+</Button>
            </div>
          </card>
        </div>
      </div>

      <cell-group class="cell-group-buy">
        <cell title="运费" :value="shipPrice?shipPrice:'免运费'"></cell>
        <cell title="赠送书币" :value="credit"></cell>
        <field label="留言" placeholder="你有什么需求写下吧" v-model="leaveComment"/>
      </cell-group>

      <submit-bar class="cart-bar" :loading="createOrderDisabled" v-if="this.cartList.length"
                  text-align="left"
                  :price="isEdit?undefined:totalPriceToPay" :label="isEdit?'':'合计：'"
                  :button-text="isEdit?'删除':'提交订单'" @submit="onSubmit"
                  :safe-area-inset-bottom="true"
      >
      </submit-bar>
    </div>

    <div>
      <Popup position="bottom" v-model="showConfirmPay"
             closeable
             close-icon="close"
             :close-on-popstate="true"
             :close-on-click-overlay="false"
      >
        <PayCardGoods
            :orderId="orderId"
            :orderType="orderType"
            :callbackUrl="callbackUrl"
            :addressInfo="defaultAddress"
            :orderPrice="totalPriceToPay"
        ></PayCardGoods>
      </Popup>
    </div>
  </div>
</template>

<script>
  import {
    Dialog, Toast, NavBar, Button, Notify, Icon, CheckboxGroup, Checkbox, CellGroup, Cell, Field,
    SubmitBar, Card, Tag, Stepper, Popup, Empty
  } from "vant";
  import TopNavbar from "../common/TopNavbar";
  import PayCardGoods from "../common/PayCardGoods";

  export default {
    name: "CartComponent",
    components: {
      PayCardGoods, TopNavbar, Dialog, Toast, Notify, NavBar, Button, Icon, Checkbox, CheckboxGroup, Cell, CellGroup,
      Field, SubmitBar, Card, Tag, Stepper, Popup, Empty
    },
    data() {
      return {
        createOrderDisabled: false,
        cartList: [],
        cartMap: {},
        checkedGoods: [],
        isEdit: false,
        editGood: {},
        editNum: 0,

        totalPriceGood: 0,
        discountPrice: 0,
        discountPriceThreshold: 0,
        shipPrice: 0,
        pricePrev: 0,
        finalPrice: 0,
        credit: 0,

        leaveComment: "",
        addressList: [],

        userRdpToUse: 0,
        userRdp: 0,

        showConfirmPay: false,
        orderId: 0,
        orderType: "",
        callbackUrl: "",
        orderStatus: "",
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        if (this.$route.query && this.$route.query.from === "buy") {
          this.cartList = this.$store.getters.orderGood;
        } else {
          this.cartList = this.$store.getters.cartGoods;
        }

        this.checkedGoods = [];
        for (let i = 0; i < this.cartList.length; i++) {
          this.checkedGoods.push(this.cartList[i].skuCombId);
          this.cartMap[this.cartList[i].skuCombId] = this.cartList[i]
        }

        this.initUserInfo()
        this.calcPrice()
      },

      getTitle(item) {
        if (item.skuExtra) {
          return item.title + ' (' + item.skuExtra + ')'
        } else {
          return item.title
        }
      },

      initUserInfo() {
        this.$store.dispatch("AccountInfoMine").then((data) => {
          if (data.code === 0 && data.data) {
            if (data.data.address) {
              this.addressList = [data.data.address]
              this.$store.commit("SetAddressList", this.addressList)
            }
          }
        })

        let addressList = this.$store.getters.addressList
        if (addressList && addressList.length > 0) {
          this.addressList = addressList
        }
      },
      async calcPrice() {
        let itemsInCart = []
        if (!this.checkedGoods.length) {
          this.finalPrice = 0;
          this.totalPriceGood = 0;
          this.pricePrev = 0
          this.shipPrice = 0;
          this.credit = 0;
          return
        }
        for (let i = 0; i < this.checkedGoods.length; i++) {
          let skuId = this.checkedGoods[i]
          let good = this.cartMap[skuId];
          itemsInCart.push({
                "id": good.goodId,
                "sku_comb_id": good.skuCombId,
                "count": good.Cartcount,
              }
          )
        }

        let params = {
          "goods": itemsInCart,
          "address": this.defaultAddress,
        }
        await this.$store.dispatch("CalcOrderGoodPrice", params).then((data) => {
          if (data.code === 0) {
            this.totalPriceGood = data.data.total_price;
            this.shipPrice = data.data.ship_price;
            this.discountPrice = data.data.price_discount;
            this.discountPriceThreshold = data.data.price_discount_threshold;
            this.pricePrev = data.data.price_prev;
            this.finalPrice = data.data.final_price;
            this.credit = data.data.credit;
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网络错误")
          console.log("error occurred")
        })
      },
      reduceCount(item, count) {
        if (!count && count !== 0) {
          Toast({
            position: "bottom",
            message: "数值不正确~"
          });
          return;
        }
        if (count <= 1) {
          Dialog.confirm({
            message: "确实要删除吗?"
          }).then(() => {
            let params = {
              delIds: [item.skuCombId],
            };
            this.$store.commit("DelCartGood", params);
            Toast("删除成功");
            this.init();
          }, ()=> {
          });
        } else {
          count--;
          item.Cartcount = count;
          this.calcPrice()
        }
      },
      addCount(item, count) {
        if (!count && count !== 0) {
          Toast({
            position: "bottom",
            message: "数值不正确~"
          });
          return;
        }
        if (count >= item.Goodcount) {
          Toast({
            position: "bottom",
            message: "只有这么多了~"
          });
          return;
        }
        count++;
        item.Cartcount = count;
        this.calcPrice()
      },
      toMyOrder() {
        this.$router.push("/order_list");
      },
      toBack() {
        this.$router.go(-1);
      },

      formatPrice(price) {
        return price.toFixed(2);
      },
      goAddressList() {
        this.$router.push('/address');
      },
      async onSubmit() {
        if (!this.checkedGoods.length) {
          Toast({
            position: "bottom",
            message: "没有商品"
          });
          return;
        }

        if (!this.defaultAddress.tel) {
          Toast({
            position: "bottom",
            message: "没有添加收货地址"
          })
          return
        }

        let orderGood = this.cartList.filter(item => {
          if (this.checkedGoods.indexOf(item.skuCombId) !== -1) {
            return item;
          }
        });
        this.doCreateOrder(orderGood);
      },
      async doCreateOrder(orderGood) {
        let orders = []
        for (let i = 0; i < orderGood.length; i++) {
          orders.push({
            "good_id": orderGood[i].goodId,
            "sku_comb_id": orderGood[i].skuCombId,
            "order_count": orderGood[i].Cartcount,
          })
        }
        let obj = {
          address: this.defaultAddress,
          order_products: orders,
          buyer_comment: this.leaveComment,
          price: {
            "total_price": this.totalPriceGood,
            "price_discount": this.discountPrice,
            "ship_price": this.shipPrice,
            "prev_price": this.pricePrev,
            "final_price": this.finalPrice,
            "credit": this.credit,
          },
        };
        // 使用的代金券  (数据类型竟然是 string)
        this.createOrderDisabled = true
        let hostName = window.location.hostname
        await this.$store.dispatch("CreateOrderGoods", obj).then(data => {
          if (data.code === 0) {
            this.orderId = data.data.order_id;
            this.orderType = data.data.order_type
            this.orderStatus = data.data.order_status
            this.callbackUrl = `${window.location.protocol}//${hostName}:${window.location.port}/order_list?_r_source=pay&order_id=${this.orderId}&user_name=${this.defaultAddress.tel}`
            console.log(this.callbackUrl)
            this.doPayOrder()
          } else if (data.code === 90001) {
            Toast.fail("订单校验错误")
          } else {
            Toast.fail("参数错误")
          }
        }, () => {
          Toast.fail("订单创建失败")
        }).catch(error => {
          Toast.fail("订单创建失败")
        });
        this.createOrderDisabled = false
      },
      doPayOrder() {
        if (this.orderStatus === "finished") { // 0 元购， 无需支付
          Toast("订单已完成")
          this.$router.push("/order_list")
        } else {
          // 进入支付组件
          this.showConfirmPay = true
        }
      },
      onCancelPay() {
        Toast("已取消支付")
        this.showConfirmPay = false
      }
    },
    computed: {
      totalPriceToPay() {
        let v = this.finalPrice * 100 - this.userRdpToUse * 100;
        if (v < 0) {
          v = 0.0
        }
        return v
      },

      hasDefaultAddress() {
        return this.addressList.length > 0
      },

      defaultAddress() {
        if (this.addressList.length > 0) {
          return this.addressList[0]
        } else {
          return {}
        }
      },

      fullAddress() {
        if (this.defaultAddress) {
          return this.defaultAddress.province + this.defaultAddress.city + this.defaultAddress.county + " " + this.defaultAddress.addressDetail;
        }
        return ""
      },
    },
    watch: {
      addressList() {
        this.calcPrice()
      }
    }
  };
</script>

<style lang="scss" scoped>
  .cart {
    background-color: #eee;
    min-height: 100vh;
    padding: 55px 10px 55px;
  }

  .address {
    position: relative;

    .address-container {
      padding: 10px 8px;
      background-color: #fff;

      .address-box {
        display: flex;
        align-items: center;
      }

      .location-add-tip {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 10px;

        .location-icon-add {
          padding: 0 5px;
        }

      }

      .address-item {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        flex: 1 1 auto;
        padding: 8px 10px;
      }

      .address-bottom {
        color: #323233;
        margin-top: 5px;

        .address-info {
          line-height: 1.2;
          font-size: 14px;
        }
      }

      .next-icon {
      }
    }
  }

  .address::after {
    content: '';
    display: block;
    height: 2px;
    background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #3283fa 0, #3283fa 45%, transparent 0, transparent 50%);
    background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #3283fa 0, #3283fa 45%, transparent 0, transparent 50%);
    background-size: 80px;
  }


  .user-info {
    font-weight: bold;
  }

  .phonenum {
    float: right;
  }

  .cart-goods {
    margin-top: 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    overflow: hidden;


    .card-goods__item {

    }
  }

  .empty-cart .van-empty__image {
    width: 90px;
    height: 90px;
  }

  .no-good {
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;

    .btn-home {
      width: 50%;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      margin-top: 12px;
    }
  }

  .cart-tags {
    margin-bottom: 1px;
    margin-top: 5px;

    .cart-sku-extra {
      color: grey;
    }

    .tag-list {
      display: flex;
      justify-content: left;
      align-items: center;
    }
  }

  .footer {
    margin-top: 5px;

    .btn {
      margin: 0;
      width: 35px;
      height: 25px;
    }

    .input {
      outline: 0;
      border: 0;
      width: 50px;
      text-align: center;
      border-bottom: 1px solid #f6b539;
      margin: 0 5px;

      .input-edit {
        padding: 0 5px;
        font-size: 14px;
        text-align: center;
        background-color: #fafafa;
        border-bottom: 1px solid #f6b539;
        margin: 0 6px;
      }
    }
  }

  /*.footer,*/
  /*.modal-box {*/
  /*  display: flex;*/
  /*  justify-content: center;*/
  /*  align-items: center;*/
  /*}*/

  /*.footer input,*/
  /*.modal-box input {*/
  /*  outline: 0;*/
  /*  border: 0;*/
  /*  width: 50px;*/
  /*  text-align: center;*/
  /*  border-bottom: 1px solid #f6b539;*/
  /*  margin: 0 6px;*/
  /*}*/

  /*.footer .input .input-edit,*/
  /*.modal-box .input .input-edit {*/
  /*  padding: 0 10px;*/
  /*  font-size: 14px;*/
  /*  text-align: center;*/
  /*  background-color: #fafafa;*/
  /*  border-bottom: 1px solid #f6b539;*/
  /*  margin: 0 6px;*/
  /*}*/

  /*.footer .btn,*/
  /*.modal-box .btn {*/
  /*  width: 30px;*/
  /*  margin: 0;*/
  /*}*/

  .selectAll {
    margin-left: 10px;
  }

  .tag-info {
    margin-right: 5px;
  }

  .cart-bar {
    /*bottom: 50px;*/
  }

  .cell-group-buy {
    margin-top: 12px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    overflow: hidden;
  }
</style>
